/**
 * Converts a number to Indian English words.
 * Uses Indian numbering system: ones, thousands, lakhs, crores.
 *
 * @param {number} amount - The amount to convert (supports up to 99,99,99,999.99)
 * @returns {string} e.g. "Rupees One Lakh Twenty Three Thousand and Fifty Paise Only"
 */

const ONES = [
  "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
  "Seventeen", "Eighteen", "Nineteen",
];

const TENS = [
  "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
];

function twoDigitWords(n) {
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10);
  const o = n % 10;
  return TENS[t] + (o ? " " + ONES[o] : "");
}

function threeDigitWords(n) {
  if (n === 0) return "";
  const h = Math.floor(n / 100);
  const rest = n % 100;
  let words = "";
  if (h) words += ONES[h] + " Hundred";
  if (h && rest) words += " ";
  if (rest) words += twoDigitWords(rest);
  return words;
}

export function amountToWords(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) return "";

  const num = Math.abs(Number(amount));
  if (num === 0) return "Rupees Zero Only";

  // Split integer and paise
  const fixed = num.toFixed(2);
  const [intPart, decPart] = fixed.split(".");
  const integer = parseInt(intPart, 10);
  const paise = parseInt(decPart, 10);

  // Indian grouping: last 3 digits, then groups of 2
  const crores = Math.floor(integer / 10000000);
  const lakhs = Math.floor((integer % 10000000) / 100000);
  const thousands = Math.floor((integer % 100000) / 1000);
  const hundreds = integer % 1000;

  const parts = [];
  if (crores) parts.push(twoDigitWords(crores) + " Crore");
  if (lakhs) parts.push(twoDigitWords(lakhs) + " Lakh");
  if (thousands) parts.push(twoDigitWords(thousands) + " Thousand");
  if (hundreds) parts.push(threeDigitWords(hundreds));

  let result = "Rupees ";
  result += parts.join(" ") || "Zero";

  if (paise > 0) {
    result += " and " + twoDigitWords(paise) + " Paise";
  }

  result += " Only";
  return result;
}
